import { createUseStyles } from 'react-jss';
import { ITheme } from '@quicktools/shared-components/styles/theme';
import { mediaQuery } from '@quicktools/shared-components/styles/helpers';

export default createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      outline: 'none',
      background: 'transparent',
      boxShadow: 'none',
      border: 0,

      '&:hover': {
        '& $inspireElement': {
          color: 'var(--x-accent-2-6)',
        },
        '& $icon': {
          fill: 'var(--x-accent-2-6)',
        },
      },

      '&[disabled]': {
        cursor: 'initial',

        '&:hover': {
          '& $inspireElement': {
            color: 'var(--x-accent-2-1)',
          },
          '& $icon': {
            fill: 'var(--x-accent-2-1)',
          },
        },
      },
    },

    inspireElement: {
      color: 'var(--x-accent-2-1)',
      fontWeight: 600,
      marginLeft: 4,
      fontSize: 14,

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: 12,
        lineHeight: '20px',
      },
      [mediaQuery(breakpoints.mobile)]: {
        display: 'none',
      },
    },
    icon: {
      fill: 'var(--x-accent-2-1)',
      width: 16,
      height: 16,

      [mediaQuery(breakpoints.mobile)]: {
        width: 24,
        height: 24,
      },
    },
    iconWarn: {
      fill: 'var(--x-status-error)',
      width: 16,
      height: 16,
    },

    '@keyframes spin': {
      from: {
        transform: 'rotate(0deg)',
      },
      to: {
        transform: 'rotate(360deg)',
      },
    },
    iconSpinner: {
      animation: '$spin 1s linear infinite',
    },
  }),
  {
    name: 'GenerateTextButton',
  },
);
